import { setStoredItem } from '../../../../../../modules/stored-item'
import isServerSide from '../../../../../../modules/is-server-side'

const isVerification = () => {
  if (!isServerSide()) {
    const isVerificationCode = window.location.search.includes('verification_code')

    if (isVerificationCode) {
      setStoredItem('userUpdate', true, true)
      return true
    }
  }
  return false
}

export default isVerification
